// @ts-nocheck
/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import dashboardCardTopRightGradient from '../../assets/images/dashboardCardTopRightGradient.svg';
import dashboardCardBottomLeftGradient from '../../assets/images/dashboardCardBottomLeftGradient.svg';
import cn from 'classnames';
import performanceBadge from '../../assets/icons/dashboardScreen/performanceBadge.svg';
import selectedEventOverViewIcon from '../../assets/icons/dashboardScreen/selectedEventOverViewIcon.svg';
import unSelectedEventOverViewIcon from '../../assets/icons/dashboardScreen/unSelectedEventOverViewIcon.svg';
import selectedChallengerIcon from '../../assets/icons/dashboardScreen/selectedChallengesIcon.svg';
import unSelectedChallengerIcon from '../../assets/icons/dashboardScreen/unSelectedChallengesIcon.svg';
import selectedLeaderBoardIcon from '../../assets/icons/dashboardScreen/selectedLeaderBoardIcon.svg';
import unSelectedLeaderBoardIcon from '../../assets/icons/dashboardScreen/unSelectedLeaderBoardIcon.svg';
import selectedReportIcon from '../../assets/icons/dashboardScreen/selectedReportIcon.svg';
import unSelectedReportIcon from '../../assets/icons/dashboardScreen/unSelectedReportIcon.svg';
import selectedPaymentIcon from '../../assets/icons/dashboardScreen/selectedPaymentIcon.svg';
import unSelectedPaymentIcon from '../../assets/icons/dashboardScreen/unSelectedPaymentIcon.svg';
import selectedEventContentIcon from '../../assets/icons/dashboardScreen/selectedVideoContentIcon.svg';
import unSelectedEventContentIcon from '../../assets/icons/dashboardScreen/unSelectedVideoContentIcon.svg';
import profileIcon from '../../assets/icons/profileIcon2.png';
import goldBadgeIcon from '../../assets/icons/dashboardScreen/goldBadgeIcon.svg';
import silverBadgeIcon from '../../assets/icons/dashboardScreen/silverBadgeIcon.svg';
import bronzeBadgeIcon from '../../assets/icons/dashboardScreen/bronzeBadgeIcon.svg';
import cloudComputingIcon from '../../assets/icons/cloudComputingIcon.svg';
import HeaderComp from './HeaderComp';
import FooterComp from './FooterComp';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAsync, useAsyncRetry } from 'react-use';
import { useEvent } from '../../hooks/useEvent';
import { useAuthentication } from '../../contexts/AuthContext';
import { useLabDeployment } from '../../hooks/useLabDeployment';
import Button from '../../components/Button';
import { useSocketNotification } from '../../contexts/NotificationContext';
import { notification } from 'antd';

function sortDeployments(deployments) {
  return deployments.sort((a, b) => {
    if (!a.createdAt && !b.createdAt) return 0;       // Both have no time
    if (!a.createdAt) return -1;                       // a has no time, comes first
    if (!b.createdAt) return 1;                        // b has no time, comes first

    // Both have createdAt, sort descending
    return new Date(b.createdAt) - new Date(a.createdAt);
  });
}

function getLatestDeployment(deployments) {
  const sorted = sortDeployments(deployments);
  return sorted[0];  // First one is either no createdAt or the latest by time
}

const Dashboard = () => {
  const { selectedEvent, sessionToken } = useAuthentication();
  const navigate = useNavigate();
  const location = useLocation();
  const [optionChanged, setOptionChanged] = useState(false);
  const { getEventLeaderBoard } = useEvent();
  const { getAllLabDeployments, startLab } = useLabDeployment();
  const { isDeploymentsLoading, getDeployments, deploymentsList } = useSocketNotification();
  const { value: leaderBoardData = [] } = useAsync(() => getEventLeaderBoard(selectedEvent?._id), [selectedEvent]);

  const currentEventLab = useMemo(() => {
    if (!deploymentsList || deploymentsList.length === 0) {
      return null;
    }
    const filteredLabs = deploymentsList.filter(
      (deployment) => ((deployment?.event?._id === selectedEvent?._id) || (deployment?.event === selectedEvent?._id))
    );

    return getLatestDeployment(filteredLabs);
  }, [deploymentsList, selectedEvent]);

  const { getEventByIdWithChallenges } = useEvent();
  const { value: eventDescription = [] } = useAsync(() =>
    getEventByIdWithChallenges(selectedEvent?._id), [selectedEvent]);

  const isEventContentVisible = useMemo(() => {
    return !!eventDescription?.courseContent?.isCourseContentPublished;
  }, [eventDescription?.courseContent?.isCourseContentPublished]);

  useEffect(() => {
    if (optionChanged) {
      navigate('/user/event-overview')
    }
    setOptionChanged(false);
  }, [optionChanged]);

  const tabOption = [
    {
      label: 'Event Overview',
      selectIcon: selectedEventOverViewIcon,
      unSelectIcon: unSelectedEventOverViewIcon,
      value: 'eventOverview',
      isVisible: true,
      path: 'event-overview',
    },
    {
      label: 'Content Library',
      selectIcon: selectedEventContentIcon,
      unSelectIcon: unSelectedEventContentIcon,
      value: 'eventContentOverview',
      isVisible: isEventContentVisible,
      path: 'event-contentOverview',
    },
    {
      label: 'Challenges',
      selectIcon: selectedChallengerIcon,
      unSelectIcon: unSelectedChallengerIcon,
      value: 'challenge',
      isVisible: selectedEvent?.type?.type !== 'VULNERABILITY_DISCLOSURE_EVENT',
      path: 'challenges',
    },
    {
      label: 'Leaderboard',
      selectIcon: selectedLeaderBoardIcon,
      unSelectIcon: unSelectedLeaderBoardIcon,
      value: 'leaderBoard',
      isVisible: selectedEvent?.type?.type !== 'VULNERABILITY_DISCLOSURE_EVENT',
      path: 'leader-board',
    },
    {
      label: 'Reports',
      selectIcon: selectedReportIcon,
      unSelectIcon: unSelectedReportIcon,
      value: 'reports',
      isVisible: selectedEvent?.type?.type === 'VULNERABILITY_DISCLOSURE_EVENT',
      path: 'reports',
    },
    {
      label: 'Payment Settings',
      selectIcon: selectedPaymentIcon,
      unSelectIcon: unSelectedPaymentIcon,
      value: 'paymentSettings',
      isVisible: selectedEvent?.type?.type === 'VULNERABILITY_DISCLOSURE_EVENT',
      path: 'payment-settings',
    }
  ];

  const visibleTabItems = tabOption.filter(item => item?.isVisible);

  const handleBadgeIcon = (rank) => {
    let badgeIcon = '';
    switch (rank) {
      case 0: badgeIcon = goldBadgeIcon;
        return badgeIcon;
      case 1: badgeIcon = silverBadgeIcon;
        return badgeIcon;
      default: badgeIcon = bronzeBadgeIcon;
        return badgeIcon;
    }
  };

  const handleDeployLab = useCallback(async () => {
    try {
      await startLab({eventId: selectedEvent?._id});
      await getDeployments();
    } catch (error) {
      notification.error({message: error.message || 'Something went wrong, Please try again!'});
    }
  }, [selectedEvent, getDeployments]);

  return (
    <>
      {/* HeaderSection */}
      <HeaderComp
        showEventOptions={true}
        setOptionChanged={setOptionChanged}
      />
      <div className="relative w-full h-auto px-12 justify-between items-start inline-flex py-[32px] bg-[#F7F7FF]">
        {/* <div className="absolute w-[347px] h-[300px] bottom-[32px] right-0 bg-no-repeat bg-[url('assets/images/dashboardCardBgImage.svg')] bg-start" /> */}
        {/* <div className={cn(`p-6 relative rounded-lg flex-col justify-start items-start gap-6 inline-flex !bg-[url('assets/images/courseCardGradientImg.svg') bg-cover bg-center`)}> */}
        <div className='w-full grid grid-cols-12 gap-[32px]'>
        <div className={cn('p-6 bg-white w-auto rounded-lg flex-col justify-start items-start gap-6 inline-flex relative', location?.pathname === '/user/event-content' ? 'col-span-12' : 'col-span-9')}>
          {/* <img src={dashboardCardTopRightGradient} alt='img' className='absolute right-0 top-0'/> */}
          {/* <img src={dashboardCardBottomLeftGradient} alt='img' className='absolute left-0 bottom-0'/> */}
          {/* <div className="w-[347.62px] h-[347.62px] opacity-30 bg-sky-600 rounded-full blur-[150px]" /> */}
          <div className={cn("justify-start items-start gap-1 lg:gap-4 inline-flex z-[1]", location?.pathname === '/user/event-content' && 'hidden')}>
            {visibleTabItems?.map((item) => (
              <div
                onClick={() => navigate(item.path)}
                className={cn("cursor-pointer p-3 md:p-1 lg:p-3 justify-start items-start gap-2 flex z-[1]",
                  location?.pathname?.includes(item?.path) && 'bg-gradient-to-b from-blue-200 to-indigo-300 rounded-[32px]')}>
                <div className="w-5 h-5 relative">
                  <img src={location?.pathname?.includes(item?.path) ? item?.selectIcon : item?.unSelectIcon} alt='icon' />
                </div>
                <div className={cn("text-base font-semibold font-['Manrope']",
                  location?.pathname?.includes(item?.path) && 'text-indigo-600 ')}>{item.label}</div>
              </div>
            ))}
          </div>
          <Outlet />
        </div>
        {selectedEvent?.type?.type !== 'VULNERABILITY_DISCLOSURE_EVENT' &&
          location?.pathname !== '/user/event-content' && (
            <div className="col-span-3">
              {leaderBoardData?.leaderboardByEvent?.length > 0 && (
              <div className="bg-white max-h-[300px] w-full sm:p-2 lg:p-4 rounded-lg flex-col justify-start items-start gap-8 inline-flex z-[1]">
                <div className="justify-start items-center gap-2 inline-flex">
                  <div className="w-5 h-5 px-[2.50px] justify-center items-center flex">
                    <div className="w-[15px] h-5 relative flex-col justify-start items-start flex">
                      <img src={performanceBadge} alt='icon' />
                    </div>
                  </div>
                  <div className="text-indigo-600 text-base font-medium font-['Manrope']">Top Performers</div>
                </div>
                <div className="w-full flex-col justify-start items-start gap-6 flex">
                  {leaderBoardData?.leaderboardByEvent?.length > 0 && leaderBoardData?.leaderboardByEvent?.map((itemData, index) => {
                    return index <= 2 && (
                      <div className='w-full grid grid-cols-12'>
                        <div className="col-span-10 justify-start items-center gap-2 flex">
                          <img className="w-10 h-10 rounded-full" src={profileIcon} alt='icon' />
                          <div className="flex-col justify-center items-start gap-1 inline-flex">
                            <div className="text-black text-base font-medium font-['Manrope'] lg:max-w-[10vw] md:max-w-[8vw] truncate break-words">
                              {itemData?.userName}
                            </div>
                            <div className="text-black text-opacity-75 text-[10px] font-normal font-['Manrope']">
                              {itemData?.totalScore} points
                            </div>
                          </div>
                        </div>
                        <div className="col-span-2 h-8 relative flex justify-end">
                          <img src={handleBadgeIcon(index)} alt='icon' width='21.75px' />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              )}
            {selectedEvent?.hasDeployment && selectedEvent?.isEventBasedDeployment && !isDeploymentsLoading && (
              <div className="bg-white max-h-[300px] rounded-lg flex-col justify-start items-start gap-4 inline-flex z-[1] w-full sm:p-2 lg:p-4 mt-6">
                <div className="justify-start items-center gap-2 inline-flex text-indigo-600 border-b pb-2">
                  <div className="px-[2.50px] justify-center items-center flex">
                    <div className="w-[40px] relative flex-col justify-start items-start flex">
                      <img src={cloudComputingIcon} alt='icon'/>
                    </div>
                  </div>
                  <h4 className="">Ready To Tackle Challenges?</h4>
                </div>
                <div className="w-full flex-col justify-start items-start gap-6 flex">
                  {(!currentEventLab || ['expired', 'destroying', 'destroyed', 'destroy_failed'].includes(currentEventLab.status)) && (
                    <>
                      <div className="bg-gradient-to-r from-indigo-50 to-white border-l-4 border-indigo-500 px-4 py-2 rounded-md shadow-sm">
                        <h2 className="text-indigo-800 tracking-wide">
                          Deploy The Hacking Lab Environment
                        </h2>
                      </div>
                      <Button customClass="h-[38px] justify-right" onClick={handleDeployLab}>
                        <div class="text-white text-base font-bold font-['Manrope']">Deploy Lab</div>
                      </Button>
                    </>
                  )}
                  {currentEventLab && currentEventLab.status === 'deployed' && (
                    <div className='w-full grid grid-cols-12'>
                      <div className="col-span-12 justify-start items-center gap-2 flex">
                        {/* <img className="w-10 h-10 rounded-full" src={profileIcon} alt='icon' /> */}
                        <div className="w-full">
                          <div class="bg-gray-50 border border-blue-300 rounded-xl p-3">
                            <h3 class="text-indigo-600 text-lg mb-4">Target Lab Details</h3>
                            <ul class="grid grid-cols-1 gap-3">
                              {Object.values(currentEventLab?.targetDetails || {}).flat().map(target => (
                                <li class="bg-gradient-to-r from-blue-400 via-blue-300 to-blue-400 text-white font-semibold rounded-xl shadow-md px-4 py-2 hover:scale-105 hover:shadow-lg transition-transform duration-200 ease-in-out break-words w-100">
                                  {target}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {currentEventLab && currentEventLab.status === 'pending' && (
                    <div className='w-full grid grid-cols-12'>
                      <div className="col-span-10 justify-start items-center gap-2 flex">
                        {/* <img className="w-10 h-10 rounded-full" src={profileIcon} alt='icon' /> */}
                        <div className="bg-gradient-to-r from-indigo-50 to-white border-l-4 border-indigo-500 px-4 py-2 rounded-md shadow-sm">
                          <div class="flex items-center space-x-2">
                            <div class="text-lg font-medium">Lab is being deployed, please wait</div>
                            <div class="flex space-x-1">
                              <span class="animate-fade-dot delay-0">.</span>
                              <span class="animate-fade-dot delay-200">.</span>
                              <span class="animate-fade-dot delay-400">.</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {currentEventLab && currentEventLab.status === 'failed' && (
                    <div className='w-full grid grid-cols-12'>
                      <div className="col-span-10 justify-start items-center gap-2 flex">
                        {/* <img className="w-10 h-10 rounded-full" src={profileIcon} alt='icon' /> */}
                        <div className="flex-col justify-center items-start gap-4 inline-flex">
                          <>
                            <div className="bg-gradient-to-r from-red-50 to-white border-l-4 border-red-500 px-4 py-2 rounded-md shadow-sm">
                              <h2 className="text-red-800 tracking-wide">
                                Lab Deployment Failed, Please try again!
                              </h2>
                            </div>
                            <Button customClass="h-[38px] justify-right" onClick={handleDeployLab}>
                              <div class="text-white text-base font-bold font-['Manrope']">Deploy Lab</div>
                            </Button>
                          </>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            </div>
          )
        }
      </div>
      </div>
      {/* <FooterSection /> */}
      <FooterComp />
    </>
  );
};

export default Dashboard;